"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var _vuex = require("vuex");

var _LotDetail = _interopRequireDefault(require("./components/LotDetail"));

var _moment = _interopRequireDefault(require("moment"));

var _AffaireTotaux = _interopRequireDefault(require("./components/AffaireTotaux"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

require("@/mixins/workflow");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  name: 'AvenantsMarchePrinc',
  components: {
    LotDetail: _LotDetail.default,
    AffaireTotaux: _AffaireTotaux.default
  },
  data: function data() {
    return {
      CONST: CONST,
      EventBus: _eventBus.EventBus,
      // pour rafraichir l'affichage apres ajout/modification/suppression d'un lot
      refresh: 0,
      // mode saisie des montants
      modeEdit: false,
      // formulaire des données
      formData: {},
      rules: {
        libelle: [{
          required: true,
          message: 'Champ obligatoire'
        }],
        mt_presente: [{
          required: true,
          message: 'Champ obligatoire'
        }],
        mt_accepte: [{
          required: true,
          message: 'Champ obligatoire'
        }],
        mt_debourse: [{
          required: true,
          message: 'Champ obligatoire'
        }]
      },
      numEntete: 0,
      nbCol: 0,
      //
      userCanDoAction: false
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user', 'affaire']), {
    // --
    entete: function entete() {
      var num = this.numEntete - 1;
      num = num < 0 ? 0 : num;
      num = num > this.entetesLength ? this.entetesLength : num;
      return this.affaire.avenantsMarchePrincipalEntetes[num];
    },
    entetesLength: function entetesLength() {
      return this.affaire.avenantsMarchePrincipalEntetes ? this.affaire.avenantsMarchePrincipalEntetes.length : 0;
    },
    // --
    mb: function mb() {
      return this.formData.mt_accepte - this.formData.mt_debourse;
    }
  }),
  beforeMount: function () {
    var _beforeMount = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this = this;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getWorkflow('gestion_mensuelle').then(function () {
                _this.userCanDoAction = _this.isUserCanDoAction(_this.affaire.affaire.etape, 'gestion_mensuelle') || false;
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeMount() {
      return _beforeMount.apply(this, arguments);
    }

    return beforeMount;
  }(),
  mounted: function mounted() {
    var _this2 = this;

    this.nbCol = this.getNbCol();

    _eventBus.EventBus.$on('AVENANT_REFRESH_ALL', function (modeEdit) {
      _this2.modeEdit = modeEdit;

      _eventBus.EventBus.$emit('MODE_EDIT', modeEdit);

      _eventBus.EventBus.$emit('REFRESH_CALCULS');
    });

    _eventBus.EventBus.$emit('REFRESH_CALCULS');
  },
  beforeDestroy: function beforeDestroy() {
    _eventBus.EventBus.$off('AVENANT_REFRESH_ALL');
  },
  methods: {
    getNbCol: function getNbCol() {
      return this.affaire.nbColAvenantMarchePrincipal;
      /*
      const avenantsMarchePrincipal = this.affaire.avenantsMarchePrincipal
      return avenantsMarchePrincipal.length > 0 ? Math.max.apply(Math, avenantsMarchePrincipal.map(function (o) { return o.num_colonne })) : 0
      */
    },
    canEdit: function canEdit() {
      // edition possible uniquement si on est sur la période de gestion courante.
      return this.affaire.YYYYMM === this.affaire.currentGestMensYYYYMM;
    },
    // pagination entete
    handleSizeChange: function handleSizeChange(val) {
      this.numEntete = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.numEntete = val;
    },
    handleNewAvenant: function handleNewAvenant() {
      this.nbCol = this.getNbCol();
      this.formData = {};
      this.formData = {
        libelle: '',
        mt_presente: null,
        mt_accepte: null,
        mt_debourse: null,
        numEntete: this.nbCol + 1
      };
      this.modeEdit = true;

      _eventBus.EventBus.$emit('MODE_EDIT', true);

      _eventBus.EventBus.$emit('AVENANT_MARCHE_PRINC_NEW');
    },
    handleEditAvenant: function handleEditAvenant() {
      this.modeEdit = true;

      _eventBus.EventBus.$emit('MODE_EDIT', true);

      var avenant = this.affaire.avenantsMarchePrincipalEntetes[this.numEntete - 1];
      this.formData = avenant;
      this.formData.numEntete = this.numEntete;

      _eventBus.EventBus.$emit('AVENANT_MARCHE_PRINC_EDIT', {
        numEntete: this.numEntete,
        idAvenantMPrinc: this.formData.id
      });
    },
    handleCancelAvenant: function handleCancelAvenant() {
      this.$refs['ElForm'].resetFields();
      this.modeEdit = false;

      _eventBus.EventBus.$emit('MODE_EDIT', false);

      _eventBus.EventBus.$emit('AVENANT_MARCHE_PRINC_CANCEL');
    },
    handleSaveAvenant: function handleSaveAvenant() {
      var _this3 = this;

      this.$refs['ElForm'].validate(function (valid) {
        if (valid) {
          var mtTotalDebourse = _this3.affaire.avenantsMarchePrincipal.reduce(function (prev, cur) {
            return prev + (cur.num_colonne === _this3.formData.numEntete ? Number(cur.mt_avenant) : 0);
          }, 0);

          if (Number(_this3.formData.mt_debourse).toFixed(2) !== Number(mtTotalDebourse).toFixed(2)) {
            _this3.$alert('Le montant déboursé S/T Fournisseurs est différent de la somme des montants de l\'avenant', 'Erreur', {
              confirmButtonText: 'Annuler',
              type: 'error'
            });

            return false;
          } // si nouvel avenant
          // console.log('onSaveAvenant index.vue', this.affaire.YYYYMM ? this.affaire.YYYYMM : '')


          if (_this3.formData.numEntete > _this3.entetesLength) {
            var data = {
              id_affaire: _this3.affaire.affaire.id,
              libelle: _this3.formData.libelle,
              mt_presente: _this3.formData.mt_presente || null,
              mt_accepte: _this3.formData.mt_accepte || null,
              mt_debourse: _this3.formData.mt_debourse || null,
              date_creation: (0, _moment.default)().format('YYYY-MM-DD HH:mm:ss'),
              periode_gestmens: _this3.affaire.YYYYMM ? _this3.affaire.YYYYMM : ''
            };

            _this3.$store.dispatch('affaire/insertAvenantMarchePrincipalEntete', data).then(function (results) {
              var numAvenant = _this3.nbCol + 1;
              _this3.numEntete = numAvenant;

              _eventBus.EventBus.$emit('MODE_EDIT', false);

              _eventBus.EventBus.$emit('AVENANT_MARCHE_PRINC_SAVE', {
                idAvenantMPrinc: results.insertId
              });

              _this3.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this3.affaire.affaire, {
                message: 'Nouvel avenant n° ' + numAvenant + ' au marché principal'
              }));
            });
          } else {
            // si mise à jour d'un avenant
            var _data = {
              id: _this3.formData.id,
              id_affaire: _this3.formData.id_affaire,
              date_creation: _this3.formData.date_creation,
              periode_gestmens: _this3.formData.periode_gestmens,
              libelle: _this3.formData.libelle,
              mt_presente: _this3.formData.mt_presente || null,
              mt_accepte: _this3.formData.mt_accepte || null,
              mt_debourse: _this3.formData.mt_debourse || null,
              date_modification: (0, _moment.default)().format('YYYY-MM-DD HH:mm:ss')
            };

            _this3.$store.dispatch('affaire/updateAvenantMarchePrincipalEntete', _data).then(function (results) {
              _eventBus.EventBus.$emit('MODE_EDIT', false);

              _eventBus.EventBus.$emit('AVENANT_MARCHE_PRINC_SAVE', {
                idAvenantMPrinc: _this3.formData.id
              });

              _this3.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this3.affaire.affaire, {
                message: 'Modification avenant n° ' + _this3.formData.numEntete + ' au marché principal'
              }));
            });
          }
        }
      });
    }
  }
};
exports.default = _default;